<style>
.centerbox {
    position: absolute;
    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);
}
</style>


<div class="centerbox box">
    <h1 class="title">Page not found!</h1>
    <h2 class="subtitle">The page you're requesting could not be found.</h2>
        <a href="/">
            <span class="icon">
                <i class="fas fa-arrow-left"></i>
            </span>
            <span>Back to safety</span>
        </a>
</div>

